import TEXT_RULES, { getBestRule } from './text-rules';
import { removeEl } from './util';
import { MAX_4U_WIDTH } from '../data/constants';


export function preRender(data, options) {
  return data;
}

export function postRender(highchart, options) {
  const R = getRules(options);
  const renderer = highchart.renderer;
  let result = {
    tagline: null,
    source: null,
    note: null,
    x: highchart.spacing[3],
    y: getStartY(highchart, options),
    width: (options.width - highchart.spacing[3] - highchart.spacing[1]) + 'px'
  };
  if (R.tagline) {
    const wsjPrintTagline = isWsjPrintTagline(options.size, 'tagline');
    const taglineAlign = getTaglineAlign(options);
    if (wsjPrintTagline) {
      result.y = options.height;
    }
    result = writeSection(R.headings, options, 'tagline', renderer, R.headings.tagline.text,
      result, taglineAlign);
    if (wsjPrintTagline) {
      result.y = options.height - 9.2;
    }
  }
  if (R.source) {
    result = writeSection(R.headings, options, 'source', renderer, R.headings.source.text, result, getSourceAlign(options));
  }
  if (R.note) {
    result = writeSection(R.headings, options, 'note', renderer, R.headings.note.text, result, getNoteAlign(options));
  }

  return result;
}


export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    const invalidTagline = invalidated.indexOf('headings/tagline') !== -1;
    const invalidSource = invalidated.indexOf('headings/source') !== -1;
    const invalidNote = invalidated.indexOf('headings/note') !== -1;

    if (invalidTagline || invalidSource || invalidNote) {
      const R = getRules(options);
      const renderer = rendered.outer.renderer;
      let info = rendered.outerInfo.info;
      if (!info) return true;
      info = info.notes;
      info.y = getStartY(rendered.outer, options);

      const taglineAlign = getTaglineAlign(options);
      if (invalidTagline) {
        removeEl(info.tagline);
        if (R.tagline) {
          info = writeSection(R.headings, options, 'tagline', renderer,
            R.headings.tagline.text, info, taglineAlign);
        } else {
          info.tagline = null;
        }
      } else if (info.tagline) {
        info.y = info.tagline.top;
      }

      if (invalidSource) {
        removeEl(info.source);
        if (R.source) {
          info = writeSection(R.headings, options, 'source', renderer, R.headings.source.text, info);
        } else {
          info.source = null;
        }
      } else if (info.source) {
        if (info.y !== info.source.y) {
          let delta = info.y - info.source.y;
          if (info.source.el) {
            let nowY = +info.source.el.element.getAttribute('y');
            info.source.el.element.setAttribute('y', nowY + delta);
          }
          info.source.y += delta;
          info.source.top += delta;
        }
        info.y = info.source.top;
      }

      if (invalidNote) {
        removeEl(info.note);
        if (R.note) {
          info = writeSection(R.headings, options, 'note', renderer, R.headings.note.text, info);
        } else {
          info.note = null;
        }
      } else if (info.note) {
        if (info.y !== info.note.y) {
          let delta = info.y - info.note.y;
          if (info.note.el) {
            let nowY = +info.note.el.element.getAttribute('y');
            info.note.el.element.setAttribute('y', nowY + delta);
          }
          info.note.y += delta;
          info.note.top += delta;
        }
        info.y = info.note.top;
      }
      return true;
    }
    return false;
  }
}


function getRules(options) {
  const rule = getBestRule(options.size);
  const headings = options.headings;
  const tagline = headings.tagline.text && headings.tagline.enabled && rule.tagline;
  const source = headings.source.text && headings.source.enabled && rule.source;
  const note = headings.note.text && headings.note.enabled && rule.note;
  return { rule, headings, tagline, source, note };
}


function writeSection(headings, options, section, renderer, text, result, align = 'left') {
  result[section] = {
    x: result.x,
    y: result.y,
    width: result.width,
    top: result.y,
    el: null,
  };
  const obj = writeText(options, renderer, text, result, align, section);
  result[section].el = obj.el;
  result[section].top = obj.top;
  result.y = obj.top;
  if ((section === 'source' || section === 'note') && options.product === 'wsj' && !options.print) {
    if (result.note && !headings.source.text) result.y -= 3;
    if (!headings.note.text && result.source) result.y -= 3;
    if (headings.note.text && headings.source.text && section === 'source') {
      result.y -= 1;
    } 
  } 
  return result;
}


// Renders a generic block of text (tagline or source) and returns the element
// and its top y.
function writeText(options, renderer, text, result, align = 'left', section = null) {
  const offsetTagline = (options.print) ? 1 : 0;
  const css = options.styles.get('small', {
    width: result.width
  });
  if (options.product === 'wsj' && !options.print) {
    css.fontSize = '13px';
    css.lineHeight = 17;
  }
  if (__WSJ__) {
    if (isWsjPrintTagline(options.size, section)) {
      css.fontFamily = "'DJ5EscrowCond Semibold'";
      css.fontSize = 6.6;
    } else if (options.size === 'print-wsj') {
      css.fontFamily = "'DJ5RetinaAgReg Medium'";
    }
  }
  if (options.id === 'print-barrons') {
    css.fontSize = 6;
  }
  const el = renderer.text(text)
    .css(css)
    .attr({
      x: align === 'left' ? result.x : parseFloat(result.width),
      y: result.y - offsetTagline,
      align
    })
    .add();
  const lines = el.element.querySelectorAll('tspan').length;
  const lineHeight = parseFloat(css.lineHeight);
  const height = lines * lineHeight;
  let yPx = result.y;
  if (lines > 1) {
    yPx = +el.element.getAttribute('y');
    yPx -= (lines - 1) * lineHeight;
    el.element.setAttribute('y', yPx);
  }
  return {
    el,
    y: yPx,
    top: yPx - lineHeight
  };
}

function getSourceAlign(options) {
  return options.product === 'marketwatch' || options.id === 'print-barrons' ? 'right' : 'left';
}

function getNoteAlign(options) {
  return options.id === 'print-barrons' ? 'right' : 'left';
}

function getTaglineAlign(options) {
  if (__WSJ__) {
    if (options.size === 'print-wsj') {
      return (options.sizes['print-wsj'].columns >= 2) ? 'right' : 'left';
    } else {
      return (options.width > MAX_4U_WIDTH) ? 'right' : 'left';
    }
  }
  if (!__WSJ__) {
    return (options.width > MAX_4U_WIDTH) ? 'right' : 'left';
  }
}

function getStartY(highchart, options) {
  return options.height - highchart.spacing[2] - yOffset(options);
}

// Lifts text just enough so that bottom line shows tails.
function yOffset(options) {
  return Math.round((parseFloat(options.styles.lineHeight.small) -
    parseFloat(options.styles.size.small)) * 0.5);
}

function isWsjPrintTagline(size, section) {
  if (__WSJ__) {
    return size === 'print-wsj' && section === 'tagline';
  }
  return false;
}


// WEBPACK FOOTER //
// ./src/chart/outer/notes.js